// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSearch as RawLucideSearch } from "lucide-react";
export const LucideSearch = /* @__PURE__ */ createIcon(RawLucideSearch, "LucideSearch", 2);
